var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.14,
    y: 6.81,
    width: 1.94,
    height: 1.94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.03,
    y: 6.81,
    width: 1.94,
    height: 1.94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.92,
    y: 6.81,
    width: 1.94,
    height: 1.94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.14,
    y: 10.69,
    width: 1.94,
    height: 1.94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.03,
    y: 10.69,
    width: 1.94,
    height: 1.94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.92,
    y: 10.69,
    width: 1.94,
    height: 1.94
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.67,1.56V.78a.78.78,0,0,0-1.56,0v.78H3.89V.78a.78.78,0,0,0-1.56,0v.78H0V14.78H14V1.56Zm1.75,12.64H.58V5.25H13.42Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.4d38e4d83b6a2f29aa0a4de246864b68.svg";
export { ForwardRef as ReactComponent };